<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <div class="logo">
        <img class="user-avatar" src="loginfiles\image\logo-min.png">丛林铝业采购系统
      </div>
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <!-- <breadcrumb></breadcrumb> -->
      <el-dropdown class="acc-container" trigger="click">
        <div class="avatar-wrapper">
          <!-- <img class="user-avatar" :src="logo"> -->
          {{ this.currentAccName }}
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <el-dropdown-item v-for="item in this.accList" v-bind:key="item.Id">
            <span @click="changeAcc(item.accountId,item.accName)" style="display:block;">{{ item.accName }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <!-- <img class="user-avatar" :src="logo"> -->
          欢迎您，{{ this.name }}
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <!-- <router-link class="inlineBlock" to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link> -->
          <el-dropdown-item>
            <span @click="changeUserInfo" style="display:block;">个人信息</span>
          </el-dropdown-item>
          <el-dropdown-item>
            <span @click="changePassword" style="display:block;">修改密码</span>
          </el-dropdown-item>
          <!-- <el-dropdown-item>
            <a href="#"></a>
          </el-dropdown-item> -->
          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>
    <el-dialog class="dialog-mini" width="500px" :title="'修改密码'" :visible.sync="dialogFormVisible"
               :close-on-click-modal="false" :append-to-body="true">
      <el-form :rules="rules" ref="dataForm" :model="temp" label-position="right" label-width="100px">

        <el-form-item size="small" :label="'旧密码'" prop="oldPwd">
          <el-input v-model="temp.oldPwd" show-password></el-input>
        </el-form-item>
        <el-form-item size="small" :label="'新密码'" prop="newPwd">
          <el-input v-model="temp.newPwd" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="passwordSubmit">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog class="dialog-mini" width="500px" :title="'个人信息'" :visible.sync="dialogUserVisible"
               :close-on-click-modal="false" :append-to-body="true">
      <el-form ref="userForm" :rules="rulesUser" :model="userObj" label-position="right" label-width="100px">
        <el-form-item size="small" :label="'姓名：'">
          {{ this.name }}
        </el-form-item>
        <el-form-item size="small" :label="'电话：'" prop="phone">
          <el-input v-model="userObj.phone" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item size="small" :label="'邮箱：'" prop="email">
          <el-input v-model="userObj.email" maxlength="50"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="dialogUserVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="userInfoSubmit">确认</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Hamburger from '@/components/Hamburger';
import * as users from '@/api/users';
import Cookies from 'js-cookie';

export default {
  data: function() {
    return {
      temp: {
        id: '', // Id
        oldPwd: '', // 旧密码
        newPwd: '' // 新密码
      },
      userObj: {
        id: '', // Id
        phone: '',
        email: ''
      },
      dialogFormVisible: false,
      dialogUserVisible: false,
      drawer: false,
      rules: { // 校验规则
        oldPwd: [{ required: true, message: '旧密码不能为空', trigger: 'blur' }],
        newPwd: [{ required: true, message: '新密码不能为空', trigger: 'blur' }]
      },
      rulesUser: {
        phone: [{ required: true, message: '电话不能为空', trigger: 'change' }],
        email: [{ required: true, message: '邮箱不能为空', trigger: 'change' }]
      }
    };
  },
  components: {
    Hamburger
  },
  computed: {
    ...mapGetters(['sidebar', 'isIdentityAuth', 'name', 'usid', 'token', 'currentAccId', 'currentAccName', 'accList'])
  },
  methods: {
    ...mapActions([
      'signOutOidc'
    ]),
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar');
    },
    logout() {
      if (this.isIdentityAuth) {
        this.signOutOidc();
      } else {
        this.$store.dispatch('LogOut').then(() => {
          location.reload(); // 为了重新实例化vue-router对象 避免bug
        });
      }
    },
    changePassword() {
      this.resetTemp();
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    changeUserInfo() {
      users.get({ id: this.usid }).then(response => {
        if (response.result) {
          this.userObj = response.result;
        }
        this.dialogUserVisible = true;
      });
    },
    passwordSubmit() {
      if (this.temp.oldPwd !== this.temp.newPwd) {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            if (this.temp.newPwd === '123456') {
              this.$message.error('新密码不能和初始密码相同');
              return;
            }
            users.changePassword(this.temp).then(response => {
              this.dialogFormVisible = false;
              this.$notify({
                title: '成功',
                message: '密码修改成功',
                type: 'success',
                duration: 2000
              });
            });
          }
        });
      } else {
        this.$message.error('新密码与旧密码相同');
      }
    },
    userInfoSubmit() {
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          this.userObj.id = this.usid;
          users.changeUserInfo(this.userObj).then(response => {
            this.dialogUserVisible = false;
            this.$notify({
              title: '成功',
              message: '个人信息修改成功',
              type: 'success',
              duration: 2000
            });
          });
        }
      });
    },
    resetTemp() {
      this.temp = {
        id: this.usid, // Id
        oldPwd: '', // 旧密码
        newPwd: '' // 新密码
      };
    },
    changeAcc(accId, accName) {
      this.$store.commit('SET_ACCID', accId);
      this.$store.commit('SET_ACCNAME', accName);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  border-bottom: 0 !important;
  background-color: #333;

  .hamburger-container {
    line-height: 44px;
    height: 44px;
    float: left;
    padding: 0 10px;
    color: white;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .acc-container {
    height: 44px;
    display: inline-block;
    position: absolute;
    line-height: 44px;
    right: 250px;
    color: white;

    .avatar-wrapper {
      cursor: pointer;
      position: relative;

      .el-icon-caret-bottom {
        position: absolute;
        right: -22px;
        top: 12px;
        font-size: 16px;
      }
    }
  }

  .avatar-container {
    height: 44px;
    display: inline-block;
    position: absolute;
    line-height: 44px;
    right: 35px;
    color: white;

    .avatar-wrapper {
      cursor: pointer;
      position: relative;

      .el-icon-caret-bottom {
        position: absolute;
        right: -22px;
        top: 12px;
        font-size: 16px;
      }
    }
  }

  .logo {
    width: 180px;
    text-align: center;
    float: left;
    color: white;

    .user-avatar {
      width: 30px;
      height: 30px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
}
</style>
